<template>
    <div class="header-wrap">
        <div class="header-content">
            <h3>
                <b>CMS管理系统</b>
                <span @click="navTab" class="aside-switch">
                    <transition name="trans">
                        <i class="icon iconfont icon-kaiguan" :class="{'trans-enter-active':isCollapse}"></i>
                    </transition>
                </span>
            </h3>
            <div class="header-info">
                <div>
                        <el-button  @click="selectSystem()" size="mini" plain type="danger" style="margin-right: 10px"><i class="el-icon-s-home" style="font-size: 14px"></i> Portal首页</el-button>
                </div>
                <el-dropdown trigger="click" class="info-user" @command="handleCommand">
                    <span class="el-dropdown-link">{{user.userNick}} ({{user.groupName}})<i class="el-icon-arrow-down el-icon--right"></i> </span>
                    <el-dropdown-menu  slot="dropdown">
                        <!--<el-dropdown-item command="a">个人中心</el-dropdown-item>
                        <el-dropdown-item command="a">设置</el-dropdown-item>-->
                        <el-dropdown-item command="updatePassword">修改密码</el-dropdown-item>
                        <el-dropdown-item command="logout">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {logout,getUserDetail} from './../api/api'

    //定义组件
    export default{
        data() {
            return {
                user: {
                    userNick: '',
                    groupName: ''
                },
                centerDialogVisible: false
            }
        },
        computed:{
            isCollapse:function(){
                return this.$store.state.navData.navIsCollapse
            },
        },
        //挂载时候执行
        mounted() {
            getUserDetail().then((res) => {
                if(res.data.status == '200'){
                    this.user = res.data.value;
                }
            })
        },
        methods:{
            selectSystem(){
                // if(param == 'csms'){
                //     window.open('https://csms.lechun.cc/csms/','_blank')
                //
                // }
                // if(param == 'scrm'){
                //     window.open('https://csms.lechun.cc/scrm','_blank')
                //
                // }
                window.open('https://portal.lechun.cc','_blank')
            },
            handleCommand(command){
               if(command=="logout"){
                   logout().then((res) => {
                       if(res.data.status==200){
                           this.$message({
                               showClose: true,
                               message: '退出登录',
                               type: 'success'
                           });
                           // this.$router.push('login')
                           let webUrl = window.location.protocol+process.env.LOGIN_URL
                           console.log('location',window.location.href)
                           let returnPage = encodeURIComponent(window.location.href)
                           window.location.href = `${webUrl}/login?auth=1&returnPage=${returnPage}`
                       }else{
                           this.$message({
                               showClose: true,
                               message: res.data.message,
                               type: 'error'
                           });
                       }
                   })
               }else if(command=="updatePassword"){
                   this.$router.push('password');
               }
            },
            navTab(){
                this.$store.commit('NAV_COLLAPSE',!this.$store.state.navData.navIsCollapse)
            }
        }
    }

</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../assets/css/public";
    $blue:#20a0ff;
    $write:#ffffff;
    .header-wrap{
        position: fixed;
        top:0;
        left: 0;
        z-index: 9;
        width: 100%;
        height: $headerHeight;
        //color: $write;
        display: -webkit-box;
        -webkit-box-pack: justify;
        -webkit-box-align: center;
        border-bottom: 1px solid #efefef;
    }
    .logo{
        display: block;
        width: $asideWidth;
        line-height: $headerHeight;
        text-align: center;
        border-right:1px solid;
        font-size:30px;
        //background: #367fa9;
    }
    .logo-mini{
        width: $asideMiniWidth;
        font-size: 20px;
    }
    .header-content{
        -webkit-box-flex: 1;
        display: -webkit-box;
        -webkit-box-pack: justify;
        height: $headerHeight;
        //background: #3c8dbc;
        h3{
            padding-left: 20px;
            line-height: $headerHeight;
            margin: 0;
            b{
                font-size: 24px;
                margin-right: 20px;
            }
        }
    }
    .header-info{
        -webkit-box-flex: 1;
        display: -webkit-box;
        -webkit-box-pack: end;
        -webkit-box-align: center;
        padding-right: 20px;
        position: relative;
    }
    .header-info img{
        width: 40px;
        height: 40px;
        display: block;
        border-radius: 2px;
    }
    .info-user{
        margin-left: 10px;
        font-size: 12px;
        //color: #ffffff;
    }
    .aside-switch{
        margin-right: 18px;
        color: #999999;
    }
    .iconfont{
        display: inline-block;
    }
    .trans-enter-active{
        animation: rotateT .5s ease forwards;
    }
    @keyframes rotateT {
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(90deg);
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Header.vue